﻿import React, {ComponentType, PropsWithChildren, useMemo} from 'react';
import {SlotType} from "../../types/Slots";

export const useSlotOrDefault = (slot: SlotType, DefaultComponent: ComponentType<PropsWithChildren>, slotProps?: any) => {
  const slotPropsMemod = useMemo(() => {
    return slotProps || {}
  }, [slotProps]);

  return useMemo(() => {
    if (React.isValidElement(slot)) {
      return slot;
    }
    return <DefaultComponent {...slotPropsMemod}>
        {slot}
      </DefaultComponent>
  }, [slot, DefaultComponent, slotPropsMemod]);
}
